export const STATUSES = [
  { id: "enquiry", label: "Enquiry", bg: "bg-sand/60", text: "text-ocean-deep", dot: "#C7B198" },
  { id: "quote_sent", label: "Quote Sent", bg: "bg-coral/15", text: "text-coral", dot: "#E27B58" },
  { id: "deposit_due", label: "Deposit Due", bg: "bg-amber-100", text: "text-amber-800", dot: "#D97706" },
  { id: "confirmed", label: "Confirmed", bg: "bg-ocean/15", text: "text-ocean-deep", dot: "#1A4960" },
];

export const EVENT_TYPES = ["Beachfront Wedding", "Backyard Party", "Boat Party", "Corporate Event", "Birthday", "Other"];

export const PACKAGES = [
  { id: "essential", label: "Essential · 4" },
  { id: "premium", label: "Premium · 6" },
  { id: "ultimate", label: "Ultimate · 8" },
];

export const ADD_ONS = [
  { id: "glassware", label: "Glassware Hire" },
  { id: "premium_ice", label: "Premium Ice" },
  { id: "garnishes", label: "Fresh Garnishes" },
];

export const statusMeta = (id) => STATUSES.find((s) => s.id === id) || STATUSES[0];

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try { return new Date(iso + (iso.length === 10 ? "T00:00:00" : "")).toLocaleDateString("en-AU", { day: "2-digit", month: "short", year: "numeric" }); }
  catch { return iso; }
};
